import {
  Component,
  EventEmitter,
  Injector,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { ControlValueAccessorConnector } from '../controlvalue-accessor.connector';
import { DcPopoverComponent } from '../dc-popover/dc-popover.component';

@Component({
  selector: 'app-dc-toggle',
  templateUrl: './dc-toggle.component.html',
  styleUrls: ['./dc-toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DcToggleComponent,
      multi: true,
    },
  ],
})
export class DcToggleComponent extends ControlValueAccessorConnector {
  @Input() disabled: boolean;
  @Input() id: string;
  @Input() labelId: string;
  @Input() label: string;
  @Input() helpText: string;
  @Output() changed = new EventEmitter<boolean>();

  @ViewChild(DcPopoverComponent)
  popover: DcPopoverComponent;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (isNullOrUndefined(this.control.value)) {
      this.control.setValue(false, { emitEvent: false });
    }
  }

  onChange(event: Event): any {
    if (this.control['readOnly']) {
      event.preventDefault();
      return false;
    }

    const { checked } = event.target as HTMLInputElement;
    
    this.onChangeFn?.(checked)
    this.changed.emit(checked);
    setTimeout(() => this.popover?.click());
  }

  toggleValue(inputRef: any): void {
    !this.control['readOnly'] && inputRef.click();
  }
}
